export const PHONE_DISPLAY = "+91 98204 23600";
export const PHONE_TEL = "tel:+919820423600";
export const INSTAGRAM_URL = "https://www.instagram.com/zonis_bakehouse";
export const INSTAGRAM_HANDLE = "@zonis_bakehouse";

export const waLink = (message) =>
  `https://wa.me/919820423600?text=${encodeURIComponent(message)}`;

export const scrollToSection = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
